import { queueError, WHITELISTED_FILES } from './error_sender.js';
import { sendUrlParams } from './tracking.js';

// onError handler
window.onerror = function (message, source, lineno, colno, error) {
    const isWhitelisted = WHITELISTED_FILES.some(file => source?.includes(file));
    if (!isWhitelisted) return;
  
    queueError({
      type: 'onerror',
      message,
      source,
      lineno,
      colno,
      stack: error?.stack || null
    });
  };
  
  // unhandledrejection handler
  window.addEventListener("unhandledrejection", function (event) {
    const sourceMatch = event.reason?.stack?.match(/(https?:\/\/[^)\n]+\.js)/);
    const source = sourceMatch?.[1] || '';
    const isWhitelisted = WHITELISTED_FILES.some(file => source.includes(file));
    if (!isWhitelisted) return;
  
    queueError({
      type: 'unhandledrejection',
      message: event.reason?.message || 'Unhandled Promise rejection',
      source,
      stack: event.reason?.stack || null
    });
  });
  
document.addEventListener('DOMContentLoaded', () => {
    sendUrlParams();
});
